import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "购票渠道",
    links: [
      { label: "FIFA官方购票", href: "/category/fifa-official" },
      { label: "授权代理商", href: "/category/authorized-agents" },
      { label: "球迷套餐", href: "/category/fan-packages" },
      { label: "官方转售平台", href: "/article/fifa-resale-platform" },
    ],
  },
  {
    title: "实用指南",
    links: [
      { label: "抢票攻略", href: "/category/ticket-tips" },
      { label: "避坑指南", href: "/category/scam-avoidance" },
      { label: "票价分析", href: "/article/ticket-price-analysis" },
      { label: "中国球迷专属", href: "/article/chinese-fans-channels" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", href: "/about" },
      { label: "联系方式", href: "/about#contact" },
      { label: "隐私政策", href: "/about" },
      { label: "免责声明", href: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-football-line text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-semibold whitespace-nowrap">
                  世界杯票务指南
                </span>
              </div>
              <p className="text-foreground-400 text-sm leading-relaxed">
                你的世界杯门票购买指南，汇总官方授权购票平台、正规渠道指南、抢票技巧及避坑建议，助你安全买到心仪门票。
              </p>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold mb-4 text-background-50">
                  {group.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-foreground-400 text-sm hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-sm">
              &copy; {new Date().getFullYear()} 世界杯票务指南。本站为第三方资讯平台，非FIFA官方或授权代理机构。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors duration-200 text-sm whitespace-nowrap" rel="nofollow">
                服务条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}